import React from 'react'

function Card({name,Image,onClickCard}) {

    return (
        <div className="col-lg-4 col-6 d-flex flex-column justify-content-center">
            <div className="panel-card d-flex flex-column justify-content-center" onClick={onClickCard}>
                <img src={Image} className="card-img-top" alt="خطا"/>
                <h3>{name}</h3>
            </div>
        </div>
    );
}

export default Card;
